document.addEventListener( 'DOMContentLoaded', function() {
  $('body').on('click','div#yotpo-reviews-star-ratings-widget',function(){
    if($('div#yotpo-reviews-main-widget').length > 0){
      $('html, body').animate({
        scrollTop: $('div#yotpo-reviews-main-widget').offset().top
      }, 4000);
    }
  })
  console.log('testimonialsContainer')
  if($('.testimonialsContainer .splide__track').length > 0){
    var splide = new Splide( '.testimonialsContainer',{
      pagination:false
    } );
    splide.mount();
    
  }
    console.log($('.videoSliderContainer'))
    var splide = new Splide( '.videoSliderContainer',{
      pagination:false,
      type:'loop',
      perPage: 5,
      padding: '5rem',
      perMove:1,
      breakpoints: {
		749: {
			perPage: 2,
		},
		1024: {
			perPage: 3,
		},
      }
    } );
    splide.mount();
    if($('.prd-add-to-cart-button').length > 0){
      $('.prd-add-to-cart-button').on('click', function(e) {
        e.preventDefault(); // prevent default action if it's a link
  
        var $form = $('.product-form');
        if ($form.length > 0) {
          $('html, body').animate({
            scrollTop: $form.offset().top - 300
          }, 4000); // smooth scroll in 600ms
        }
      });
    }
  if($('.videoContainer .videoInnerContainer iframe').length > 0){
    setTimeout(() => {
        console.log('after 3 sec of page load')
      $('.videoContainer .videoInnerContainer iframe').each((k,v) => {
        console.log($(v))
        let src = $(v).attr('data-iframe-src')
        $(v).attr('src',src)
      })
      
    },2000)
  }
  } );